export default __webpack_public_path__ + "static/media/login-dark.200941ca.svg";